import React from "react";
import Modal from "../common/Modal";
import { useTranslation } from 'react-i18next';
import { formatDateTime } from "../../utils/dateUtils";
import "./FeedbackModal.css";

const FeedbackModal = ({ isOpen, onClose, feedbacks, totalFeedbacks, page, fetchFeedbacks, selectedStoryId }) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <h2>{t('myStories.storyFeedbacks')}</h2>
            {feedbacks.length === 0 ? (
                <p>{t('myStories.noFeedbacks')}</p>
            ) : (
                feedbacks.map((feedback) => (
                    <div key={feedback._id} className="feedback-item">
                        <div className="feedback-item-header">
                            <strong>{feedback.userId.name}</strong> {feedback.reaction === 'like' ? (<span>👍</span>) : (feedback.reaction === 'dislike' ? (<span>👎</span>) : <></>)} <span className="feedback-date">{formatDateTime(feedback.createdAt)}</span>
                        </div>
                        <p> {feedback.feedbackText}</p>
                    </div>
                ))
            )}

            {/* Pagination */}
            {totalFeedbacks > 5 && (
                <div className="pagination">
                    <button disabled={page === 1} onClick={() => fetchFeedbacks(selectedStoryId, page - 1)}>⬅️</button>
                    <button disabled={page * 5 >= totalFeedbacks} onClick={() => fetchFeedbacks(selectedStoryId, page + 1)}>➡️</button>
                </div>
            )}
        </Modal>
    );
};

export default FeedbackModal;
